import React, { FC, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { NolPromotionStore } from '@/stores/NolPromotionStore';

import Version0825Body from '@/components/NolPromotion/NolPromotionBody/Version0825';
import Version1020Body from '@/components/NolPromotion/NolPromotionBody/Version1020';

interface NolPromotionBodyProps {
  version: string;
  store: NolPromotionStore;
}

const NolPromotionBody: FC<NolPromotionBodyProps> = ({ version, store }) => {
  /*
  날짜별 본문 컴포넌트 선정
   */
  const VersionBody = useMemo(() => {
    const v = parseInt(version);
    if (v >= 33) {
      return (
        <Version1020Body
          eventNolCouponPeriod={'2026년 10월 20일 (화) ~ 2026년 12월 14일 (월)'}
          eventPeriod={'2026년 10월 20일 (화) ~ 2026년 12월 14일 (월)'}
          eventCashbackPeriod={'2025년 05월 29일 (화) ~ 2025년 09월 29일 (월)'}
          eventBefore6MonthPeriod={'2024.08.04 ~ 2025.02.03'}
          eventDisabledCashbackList={[
            '23년 4월 18일부터 24년 1월 29일까지 진행된 NOL 카드 첫 결제 청구할인 이벤트',
            '24년 1월 30일부터 25년 2월 3일까지 진행된 NOL 카드 첫 결제 캐시백 이벤트',
            '23년 11월 16일부터 24년 9월 30일까지 진행된 NOL 스테이지 3만원 쿠폰할인 이벤트',
            '24년 11월 26일부터 25년 2월 3일까지 진행된 야놀자 골드클래스 전용 이벤트',
            '24년 12월 10일부터 25년 2월 3일까지 진행된 인터파크 티켓 중복할인 쿠폰 이벤트 (뮤지컬, 전시 등)',
          ]}
          eventCashbackDate={'25년 4월 말일 경'}
          store={store}
        />
      );
    }
    return (
      <Version0825Body
        eventNolCouponPeriod={'2026년 8월 25일 (화) ~ 2026년 10월 19일 (월)'}
        eventPeriod={'2026년 8월 25일 (화) ~ 2026년 10월 19일 (월)'}
        eventCashbackPeriod={'2025년 05월 29일 (화) ~ 2025년 09월 29일 (월)'}
        eventBefore6MonthPeriod={'2024.08.04 ~ 2025.02.03'}
        eventDisabledCashbackList={[
          '23년 4월 18일부터 24년 1월 29일까지 진행된 NOL 카드 첫 결제 청구할인 이벤트',
          '24년 1월 30일부터 25년 2월 3일까지 진행된 NOL 카드 첫 결제 캐시백 이벤트',
          '23년 11월 16일부터 24년 9월 30일까지 진행된 NOL 스테이지 3만원 쿠폰할인 이벤트',
          '24년 11월 26일부터 25년 2월 3일까지 진행된 야놀자 골드클래스 전용 이벤트',
          '24년 12월 10일부터 25년 2월 3일까지 진행된 인터파크 티켓 중복할인 쿠폰 이벤트 (뮤지컬, 전시 등)',
        ]}
        eventCashbackDate={'25년 4월 말일 경'}
        store={store}
      />
    );
  }, [version]);

  return <div>{VersionBody}</div>;
};

export default observer(NolPromotionBody);
